module.exports = __webpack_public_path__ + "static/media/dot.1b2f8179.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/FormSMS/dot.svg
// module id = 1620
// module chunks = 0